module.exports = __webpack_public_path__ + "img/help.0e1d654d.png";